import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import {
  Tabs,
  Card,
  Collapse,
  Descriptions,
  Popconfirm,
  message,
  Button,
} from "antd";

import storageUtils from "../../utils/storageUtils";
import {
  req_single_gam_graduateFresh,
  req_edit_gam_graduateFresh,
} from "../../api";

const { Panel } = Collapse;
const { TabPane } = Tabs;

class GraduateSingle extends Component {
  // 基礎通用參數 //////////////////////////////////////////////

  static propTypes = {
    graduate: PropTypes.object.isRequired,
  };

  state = {
    loading: false,
    item: {},
    labelText: new Date().getMonth() + 1 > 6 ? "畢業後狀態" : "預劃畢業後出入",
    descriptionText:
      new Date().getMonth() + 1 > 6 ? "當前生活狀況" : "概述未來規劃",
    readmeText:
      new Date().getMonth() + 1 > 6
        ? "說明當前工作或待業/升學狀況"
        : "說明預劃畢業後未來生涯",
    nowMonth: new Date().getMonth() + 1,
  };

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleAgree = this.handleAgree.bind(this);
    this.handleDisagree = this.handleDisagree.bind(this);
  }

  UNSAFE_componentWillMount() {}

  componentDidMount() {
    this.api_single_graduateFresh();
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_single_graduateFresh = async () => {
    const { token } = this.props.user;
    const { StudentId } = this.props.graduate;
    this.setState({ loading: true });
    const result = await req_single_gam_graduateFresh(StudentId, token);
    this.setState({ loading: false });

    const item = result;
    item.AgreePrivacy = item.AgreePrivacy === "YES" ? true : false;
    item.ConfirmStatus = item.ConfirmStatus === "YES" ? true : false;
    item.ConfirmOperator = this.setState({ item });
  };

  api_edit_graduateFresh = async (item) => {
    const result = await req_edit_gam_graduateFresh(
      item,
      storageUtils.getUser().token
    );
    if (result.status === "success") {
      // console.log(result)
      message.success(result.message);
      this.api_single_graduateFresh();
    } else {
      message.error(result.message);
    }
  };

  api_edit_graduateWork = async (item) => {
    await req_edit_gam_graduateFresh(item, storageUtils.getUser().token);
  };

  ///////////////////////////////////////////////////////////

  handleChange(event) {
    const { item } = this.state;
    //console.log(event)
    Object.keys(item).forEach((propertyName) => {
      if (event.target.id === "AgreePrivacy" && event.target.value !== null) {
        // Checkbox
        item.AgreePrivacy = event.target.checked;
      } else {
        if (event.target.id === propertyName && event.target.value !== null) {
          item[propertyName] = event.target.value.trim();
        }
      }
    });
    this.setState({ item });
  }

  handleSubmit(event) {
    event.preventDefault();
    // const { nowMonth } = this.state;
    const row = this.state.item;
    const errors = [];

    if (!row.MobilePrincipal.trim()) {
      errors.push("手機未填");
    }

    if (!row.EmailPrincipal.trim()) {
      errors.push("電子郵件未填");
    }

    if (!row.MailingAddress.trim()) {
      errors.push("通訊地址未填");
    }

    if (row.PlanStatusPrimary.trim() === "尚待確認") {
      errors.push("未來規劃未選");
    }
    row.AgreePrivacy = row.AgreePrivacy === true ? "YES" : "NO";

    if (errors.length === 0) {
      // console.log(row)
      row.ConfirmOperator = storageUtils.getUser().userCode;
      row.ConfirmStatus = "YES";
      row.condition = "BASE";
      this.api_edit_graduateFresh(row);
      if (row.PlanStatusPrimary === "就業") {
        row.condition = "WORK";
        this.api_edit_graduateWork(row);
      }
    } else {
      let info = errors.join(",");
      message.error(info);
    }
  }

  handleAgree() {
    const row = this.state.item;
    row.AgreePrivacy = true;
    this.setState({ item: row });
  }

  handleDisagree() {
    const row = this.state.item;
    row.AgreePrivacy = false;
    this.setState({ item: row });
  }

  /////////////////////////////
  render() {
    const { labelText, descriptionText, readmeText, nowMonth } = this.state;
    const {
      TwId,
      StudentName,
      GraduateYear,
      GraduateMonth,
      Degree,
      EducationalSystem,
      University,
      Division,
      CollegeName,
      DepartmentName,
      ClassGradeName,
      ClassTeacherName,
      Sex,
      Birthday,
      MobilePrincipal,
      MobileSpare,
      TelephonePrincipal,
      TelephoneSpare,
      EmailPrincipal,
      EmailSpare,
      MailingAddress,
      ResidentAddress,
      AgreePrivacy,
      PlanStatusPrimary,
      PlanStatusDescription,
      ConfirmStatus,
      //工作
      JobType,
      JobTitle,
      JobCompany,
      JobDepartment,
      JobTelephone,
      JobAddress,
      JobBossName,
      JobBossEmail,
    } = this.state.item;

    return (
      <Tabs defaultActiveKey="1">
        <TabPane tab="須確認資料" key="1">
          <form onSubmit={this.handleSubmit}>
            <Collapse defaultActiveKey={["1"]}>
              <Panel
                header="通聯方式 (可點開確認)"
                key={ConfirmStatus === false ? "1" : "2"}
              >
                <div>
                  <div className="form-row">
                    <div className="col-lg">
                      <div className="form-group">
                        <label>
                          <span className="text-danger">*</span>主要行動電話
                        </label>
                        <input
                          type="text"
                          className="form-control text-primary"
                          name="MobilePrincipal"
                          id="MobilePrincipal"
                          aria-describedby="mobileHelp"
                          placeholder="請輸入您常用行動電話"
                          defaultValue={MobilePrincipal}
                          onChange={this.handleChange}
                        />
                        <small id="mobileHelp" className="form-text text-muted">
                          當您自學校畢業後，學校日後有任何校友優惠、活動及服務將透過行動電話來通知您
                        </small>
                      </div>
                    </div>
                    <div className="col-lg">
                      <div className="form-group">
                        <label>備用行動電話</label>
                        <input
                          type="text"
                          className="form-control text-primary"
                          name="MobileSpare"
                          id="MobileSpare"
                          placeholder="請輸入您備用行動電話"
                          defaultValue={MobileSpare}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="col-lg">
                      <div className="form-group">
                        <label>
                          <span className="text-danger">*</span>主要電子郵件
                        </label>
                        <input
                          type="email"
                          className="form-control text-primary"
                          name="EmailPrincipal"
                          id="EmailPrincipal"
                          aria-describedby="emailHelp"
                          placeholder="請輸入您常用電子郵件"
                          defaultValue={EmailPrincipal}
                          onChange={this.handleChange}
                        />
                        <small id="emailHelp" className="form-text text-muted">
                          當您自學校畢業後，學校日後有任何校友優惠、活動及服務將透過電子郵件來通知您
                        </small>
                      </div>
                    </div>
                    <div className="col-lg">
                      <div className="form-group">
                        <label>備用電子郵件</label>
                        <input
                          type="email"
                          className="form-control text-primary"
                          name="EmailSpare"
                          id="EmailSpare"
                          placeholder="請輸入您備用電子郵件"
                          defaultValue={EmailSpare}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="col-lg-8">
                      <div className="form-group">
                        <label>
                          <span className="text-danger">*</span>通訊地址
                        </label>
                        <input
                          type="text"
                          className="form-control text-primary"
                          name="MailingAddress"
                          id="MailingAddress"
                          placeholder="請輸入您目前通訊地址"
                          defaultValue={MailingAddress}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg">
                      <div className="form-group">
                        <label>通訊地址室內電話</label>
                        <input
                          type="text"
                          className="form-control text-primary"
                          ame="TelephonePrincipal"
                          id="TelephonePrincipal"
                          nplaceholder="請輸入您通訊地址室內電話"
                          defaultValue={TelephonePrincipal}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="col-lg-8">
                      <div className="form-group">
                        <label>戶籍地址</label>
                        <input
                          type="text"
                          className="form-control text-primary"
                          name="ResidentAddress"
                          id="ResidentAddress"
                          placeholder="請輸入您戶籍地址"
                          defaultValue={ResidentAddress}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg">
                      <div className="form-group">
                        <label>戶籍地址室內電話</label>
                        <input
                          type="text"
                          className="form-control text-primary"
                          name="TelephoneSpare"
                          id="TelephoneSpare"
                          placeholder="請輸入您戶籍地址室內電話"
                          defaultValue={TelephoneSpare}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Panel>
            </Collapse>
            <Card>
              <div className="form-row">
                <div className="col-lg-2">
                  <div className="form-group">
                    <label>
                      <span className="text-danger ">*{labelText}</span>
                    </label>
                    <select
                      name="PlanStatusPrimary"
                      id="PlanStatusPrimary"
                      className="custom-select mb-3 text-success"
                      defaultValue={PlanStatusPrimary}
                      onChange={this.handleChange}
                      key={PlanStatusPrimary}
                    >
                      <option value="尚待確認">請選擇</option>
                      <option value="就業">就業</option>
                      <option value="待業">待業</option>
                      <option value="服役">服役(義務役)</option>
                      <option value="升學">升學</option>
                      <option value="留學">留學</option>
                      <option value="其他">其他</option>
                    </select>
                  </div>
                </div>
                <div className="col-lg">
                  <div className="form-group">
                    <label>{descriptionText}</label>
                    <input
                      type="text"
                      className="form-control text-primary"
                      id="PlanStatusDescription"
                      placeholder={readmeText}
                      defaultValue={PlanStatusDescription}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
              </div>
              {ConfirmStatus === false ? (
                <div className="form-row">
                  <div className="form-group form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      name="AgreePrivacy"
                      id="AgreePrivacy"
                      defaultChecked={AgreePrivacy}
                      onChange={this.handleChange}
                    />
                    <label className="form-check-label">
                      <Popconfirm
                        title="因應個人資料保護法及本校個人資料管理規定，本校在向您蒐集個人資料之前，依法向您告知下列事項，當您勾選「我同意」，表示您已閱讀、瞭解並同意接受本同意書之所有內容：
                                                    一、蒐集目的及類別
                                                    為提供活動各項通知服務、報名資料確認、寄送本校或產業相關活動訊息及本校內部管理使用之蒐集目的，而須獲取您下列個人資料類別： 姓名、電話、E-mail 或其他得以直接或間接識別您個人之資料。
                                                    二、個人資料利用之期間、地區、對象及方式
                                                    您的個人資料，除涉及國際業務或活動外，僅供本校及活動協辦單位於中華民國領域，於上述蒐集目的之必要合理範圍內加以利用至前述蒐集目的消失時為止。
                                                    
                                                    三、當事人權利行使
                                                    依據個人資料保護法第3條規定，您可向本校請求查詢或閱覽、製給複製本、補充或更正、停止蒐集/處理/利用或刪除您的個人資料。
                                                    
                                                    四、不提供個人資料之權益影響
                                                    如您不提供或未提供正確之個人資料，或要求停止蒐集/處理/利用/刪除個人資料、服務訊息的取消訂閱，本校將無法為您提供蒐集目的之相關服務。
                                                    
                                                    五、各項通知服務、相關訊息之停止寄送，或違反本個資聲明之行為。您可於上班時間聯繫承辦人（電話06-2535642，分機 227、229）反映。
                                                     
                                                    個人資料同意提供：
                                                    一、本人確已閱讀並瞭解上述告知事項，並勾選「我同意」授權貴校於所列目的之必要合理範圍內，蒐集、處理及利用本人之個人資料。
                                                    二、本人瞭解此同意書符合個人資料保護法及相關法規之要求，並提供予貴校留存及日後查證使用。"
                        okText="同意"
                        cancelText="不同意"
                        onConfirm={this.handleAgree}
                        onCancel={this.handleDisagree}
                      >
                        <Button type="link">
                          同意蒐集個人資料告知事項暨個人資料提供
                        </Button>
                      </Popconfirm>
                    </label>
                  </div>
                </div>
              ) : (
                <></>
              )}
              {PlanStatusPrimary === "就業" && nowMonth > 6 ? (
                <>
                  <div className="form-row">
                    <div className="col-lg-2">
                      <div className="form-group">
                        <label>主要工作型態</label>
                        <select
                          name="JobType"
                          id="JobType"
                          className="custom-select mb-3 text-success"
                          defaultValue={JobType}
                          onChange={this.handleChange}
                          key={JobType}
                        >
                          {" "}
                          <option value="">請選擇</option>
                          <option value="全職">全職</option>
                          <option value="兼職">兼職</option>
                          <option value="正職">正職</option>
                          <option value="約聘">約聘</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-lg-10">
                      <div className="form-group">
                        <label>工作職稱</label>
                        <input
                          type="text"
                          className="form-control text-primary"
                          name="JobTitle"
                          id="JobTitle"
                          placeholder="負責人/經理/業務...."
                          defaultValue={JobTitle}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="col-lg-3">
                      <div className="form-group">
                        <label>機構名稱</label>
                        <input
                          type="text"
                          className="form-control text-primary"
                          name="JobCompany"
                          id="JobCompany"
                          placeholder="政府組織/公司企業/店名/工作室 名稱"
                          defaultValue={JobCompany}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg-2">
                      <div className="form-group">
                        <label>隸屬部門</label>
                        <input
                          type="text"
                          className="form-control text-primary"
                          name="JobDepartment"
                          id="JobDepartment"
                          placeholder="部門名稱"
                          defaultValue={JobDepartment}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg-3">
                      <div className="form-group">
                        <label>聯絡電話</label>
                        <input
                          type="text"
                          className="form-control text-primary"
                          name="JobTelephone"
                          id="JobTelephone"
                          placeholder="政府組織/公司企業/店名/工作室 電話"
                          defaultValue={JobTelephone}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="form-group">
                        <label>聯絡地址</label>
                        <input
                          type="text"
                          className="form-control text-primary"
                          name="JobAddress"
                          id="JobAddress"
                          placeholder="政府組織/公司企業/店名/工作室 地址"
                          defaultValue={JobAddress}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="col-lg-5">
                      <div className="form-group">
                        <label>負責人(或主管)姓名</label>
                        <input
                          type="text"
                          className="form-control text-primary"
                          name="JobBossName"
                          id="JobBossName"
                          placeholder="負責人/主管/雇主 姓名"
                          defaultValue={JobBossName}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg">
                      <div className="form-group">
                        <label>負責人(或主管)電子郵件</label>
                        <input
                          type="text"
                          className="form-control text-primary"
                          name="JobBossEmail"
                          id="JobBossEmail"
                          placeholder="負責人/主管/雇主 電子郵件"
                          defaultValue={JobBossEmail}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <></>
              )}
              <div className="form-row">
                {ConfirmStatus === false ? (
                  <input
                    type="submit"
                    value="確認"
                    className="btn btn-primary btn-sm"
                    style={{ width: "100%" }}
                    disabled={!AgreePrivacy}
                  />
                ) : (
                  <input
                    type="submit"
                    value="修訂"
                    className="btn btn-warning btn-sm"
                    style={{ width: "100%" }}
                    disabled={!AgreePrivacy}
                  />
                )}
                <span></span>
              </div>
            </Card>
          </form>
        </TabPane>
        <TabPane tab="已確認資料" key="2">
          <Collapse defaultActiveKey={["1"]}>
            <Panel header="個人資料" key="1">
              <Descriptions
                bordered
                column={{ xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }}
              >
                <Descriptions.Item label="姓名">
                  {StudentName}
                </Descriptions.Item>
                <Descriptions.Item label="身份證字號">{TwId}</Descriptions.Item>
                <Descriptions.Item label="性別">{Sex}</Descriptions.Item>
                <Descriptions.Item label="生日">{Birthday}</Descriptions.Item>
              </Descriptions>
            </Panel>
            <Panel header="畢業學歷" key="2">
              <Descriptions
                bordered
                column={{ xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }}
              >
                <Descriptions.Item label="畢業年月">
                  {GraduateYear} / {GraduateMonth}
                </Descriptions.Item>
                <Descriptions.Item label="校名">{University}</Descriptions.Item>
                <Descriptions.Item label="學系">
                  {DepartmentName}
                </Descriptions.Item>
                <Descriptions.Item label="學位">{Degree}</Descriptions.Item>
              </Descriptions>
            </Panel>
            <Panel header="在校資訊" key="3">
              <Descriptions
                bordered
                column={{ xxl: 6, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }}
              >
                <Descriptions.Item label="部別">{Division}</Descriptions.Item>
                <Descriptions.Item label="學制">
                  {EducationalSystem}
                </Descriptions.Item>
                <Descriptions.Item label="學院">
                  {CollegeName}
                </Descriptions.Item>
                <Descriptions.Item label="學系">
                  {DepartmentName}
                </Descriptions.Item>
                <Descriptions.Item label="班級">
                  {ClassGradeName}
                </Descriptions.Item>
                <Descriptions.Item label="班導">
                  {ClassTeacherName}
                </Descriptions.Item>
              </Descriptions>
            </Panel>
          </Collapse>
        </TabPane>
      </Tabs>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(GraduateSingle);
